/**
 *
 * BIGTINCAN - CONFIDENTIAL
 *
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the property of BigTinCan Mobile Pty Ltd and its suppliers,
 * if any. The intellectual and technical concepts contained herein are proprietary to BigTinCan Mobile Pty Ltd and its
 * suppliers and may be covered by U.S. and Foreign Patents, patents in process, and are protected by trade secret or
 * copyright law. Dissemination of this information or reproduction of this material is strictly forbidden unless prior
 * written permission is obtained from BigTinCan Mobile Pty Ltd.
 *
 * @package gs-dxc-wws
 * @copyright 2010-2020 BigTinCan Mobile Pty Ltd
 * @author Shibu Bhattarai <shibu.bhattarai@bigtincan.com>
 */

import { ApiBase } from '../base';
import { Result } from '../../model';
import { TeamEvent, TeamEventCard } from '../../model/api/graph';

class GraphService extends ApiBase {

  public async getEvent(chatId:string): Promise<Result<TeamEvent>> {
    // we will need tp remove the static value here
    const result = await this.doGet<any>(`/api/graph/event/${chatId}`, {
      headers: {
        'Content-Type': 'application/json',
      },
    });
    return result;
    }

    public async getAllEvents(scheduledDate: Date): Promise<Result<TeamEventCard[]>> {
        // we will need tp remove the static value here
        scheduledDate = new Date(scheduledDate.toLocaleDateString('en-US'));  
        const result = await this.doGet<any>(`/api/graph/events/${scheduledDate.toJSON()}`, {
            headers: {
                'Content-Type': 'application/json',
            },
        });

        return result;
    }

    public async addAppToMeeting(chatId: string): Promise<Result<string>> {
        const request = { chatId: chatId }
        const result = await this.doPost<any>(`/api/graph/addAppToMeeting` ,request, {
            headers: {
                'Content-Type': 'application/json',
            },
        });
        return result;
    }
}
const graphService = new GraphService();
export default graphService;
